/**
 * <s-ticker>: shows one list item at a time and glides to the next every few seconds (data-interval ms,
 * default 3200). Pauses on hover/focus and off screen. Reduced motion: stays on the first item.
 */
class STicker extends HTMLElement {
  #timer = 0;
  #index = 0;
  #items = [];
  #paused = false;
  #visible = false;
  #io = null;

  connectedCallback() {
    this.#items = [...this.querySelectorAll('li')];
    if (!this.#items.length) return;
    this.#items[0].setAttribute('data-active', '');
    if (this.#items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.addEventListener('pointerenter', () => { this.#paused = true; });
    this.addEventListener('pointerleave', () => { this.#paused = false; });
    this.addEventListener('focusin', () => { this.#paused = true; });
    this.addEventListener('focusout', () => { this.#paused = false; });
    this.#io = new IntersectionObserver(([entry]) => {
      this.#visible = entry.isIntersecting;
      this.#schedule();
    });
    this.#io.observe(this);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    this.#io?.disconnect();
  }

  #schedule() {
    window.clearTimeout(this.#timer);
    if (!this.#visible) return;
    const interval = Number(this.dataset.interval) || 3200;
    this.#timer = window.setTimeout(() => {
      if (!this.#paused && !document.hidden) this.#next();
      this.#schedule();
    }, interval);
  }

  #next() {
    const current = this.#items[this.#index];
    this.#index = (this.#index + 1) % this.#items.length;
    const next = this.#items[this.#index];
    for (const item of this.#items) item.removeAttribute('data-leaving');
    current.removeAttribute('data-active');
    current.setAttribute('data-leaving', '');
    next.setAttribute('data-active', '');
  }
}

if (!customElements.get('s-ticker')) customElements.define('s-ticker', STicker);
